// extracted by mini-css-extract-plugin
module.exports = {"underline":"TenantSetting_underline__1G-ZY"};